import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import BottomNav from "@/components/BottomNav";
import BrandLoader from "@/components/BrandLoader";

import Auth from "@/pages/Auth";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import PriceIndex from "@/pages/PriceIndex";
import PostListing from "@/pages/PostListing";
import Messages from "@/pages/Messages";
import Chat from "@/pages/Chat";
import Profile from "@/pages/Profile";
import ListingDetail from "@/pages/ListingDetail";
import Favorites from "@/pages/Favorites";
import Notifications from "@/pages/Notifications";
import Compare from "@/pages/Compare";
import PushBridge from "@/components/PushBridge";

function Splash() {
  return <BrandLoader />;
}

function Layout() {
  const { user, checked } = useAuth();
  const { pathname } = useLocation();
  if (!checked || user === null) return <Splash />;
  if (!user) return <Navigate to="/auth" replace />;
  const hideNav = /^\/messages\/[^/]+$/.test(pathname) || /^\/listing\//.test(pathname);
  return (
    <div className="app-shell" style={{ paddingBottom: hideNav ? 0 : 96 }}>
      <AnimatePresence mode="wait">
        <Outlet />
      </AnimatePresence>
      {!hideNav && <BottomNav />}
      <PushBridge />
    </div>
  );
}

function App() {
  const [booting, setBooting] = useState(true);
  return (
    <ThemeProvider>
      {booting && <BrandLoader onFinish={() => setBooting(false)} />}
      <AuthProvider>
        <CurrencyProvider>
          <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/auth" element={<Auth />} />
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/browse" element={<Browse />} />
                <Route path="/prices" element={<PriceIndex />} />
                <Route path="/prices/:symbol" element={<PriceIndex />} />
                <Route path="/post" element={<PostListing />} />
                <Route path="/post/:editId" element={<PostListing />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/messages/:convId" element={<Chat />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/u/:userId" element={<Profile />} />
                <Route path="/favorites" element={<Favorites />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/listing/:id" element={<ListingDetail />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CurrencyProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
